import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { collaborationsApi } from './redux/collaborationsApi'
import { messagesApi } from './redux/messagesApi'
import userReducer from './redux/userSlice'
import documentsReducer from './redux/documentsSlice'
import mockStateJson from './data/mockState.json'

const rootReducer = combineReducers({
  user: userReducer,
  documents: documentsReducer,
  [collaborationsApi.reducerPath]: collaborationsApi.reducer,
  [messagesApi.reducerPath]: messagesApi.reducer,
})

const isMockMode = import.meta.env.VITE_MOCK_STATE === 'true'

export const store = configureStore({
  reducer: rootReducer,
  // API data comes from the mock baseQuery (src/mock); only the signed-in user is preloaded
  preloadedState: isMockMode
    ? ({
        user: mockStateJson.user,
        documents: mockStateJson.documents,
      } as unknown as Partial<ReturnType<typeof rootReducer>>)
    : undefined,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(collaborationsApi.middleware, messagesApi.middleware),
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
